import { tips } from "@/mocks/content";

export default function TipsSection() {
  return (
    <section id="tips" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-accent-700">
            <i className="ri-lightbulb-line"></i>
            追剧攻略
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            六个让观感更好的追剧习惯
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700">
            同样的剧，用不同的方式看，体验会差很多。下面这些习惯看似细碎，
            但分别对应字幕、节奏、剧透、片单管理和渠道选择等常见痛点，按需取用即可。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {tips.map((tip, index) => (
            <article
              key={tip.title}
              className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-md ${
                  index % 2 === 0 ? "bg-primary-100 text-primary-700" : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <i className={`${tip.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-700">{tip.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}